<app-componente-kit-montagem *ngFor="let componente of componentes" [item]="item" [grupo]="componente" (alterou)="alterou.emit()"></app-componente-kit-montagem>

<aside class="kit-total" *ngIf="componentes.length && resumoUnidades" [class.kit-total--multiplo]="item.qtde > 1">
  <div class="kit-total__linha">
    <span class="kit-total__icone" aria-hidden="true">{{item.qtde > 1 ? item.qtde + '×' : '1×'}}</span>
    <div class="kit-total__texto">
      <strong>{{item.qtde > 1 ? item.qtde + ' kits' : 'Cada kit'}}</strong>
      <span>{{resumoUnidades}}</span>
      <small class="kit-total__escolhidos" *ngFor="let l of escolhidos"><ng-container *ngIf="componentes.length > 1">{{l.grupo}}: </ng-container>{{l.texto}}</small>
    </div>
  </div>
  <small class="kit-total__dica" *ngIf="item.qtde <= 1 && todosFixos">Para levar mais, aumente a quantidade de kits antes de adicionar.</small>
</aside>

<section *ngIf="config && !componentes.length" class="kit-grupo" [class.kit-grupo--completo]="!erro">
  <header class="kit-grupo__cabecalho">
    <div class="kit-grupo__titulo">
      <h3>Quantos você quer?</h3>
      <span class="kit-pill" *ngIf="item.qtdeUnidadesKit">{{item.qtdeUnidadesKit}} un.</span>
    </div>
  </header>
  <div class="kit-escolha" *ngIf="config.modalidadeQuantidade === 'FECHADA'">
    <div class="kit-chips">
      <button type="button" class="kit-chip" *ngFor="let t of tamanhos" (click)="tamanho(t)" [class.kit-chip--selecionado]="item.produtoTamanho?.id === t.id">
        <strong>{{t.descricao}}</strong>
        <span>{{t.qtdeUnidades}} un. · {{(t.novoPreco != null ? t.novoPreco : t.preco) | currency:'BRL'}}</span>
      </button>
    </div>
  </div>
  <div class="kit-escolha" *ngIf="config.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE'">
    <div class="kit-escolha__linha">
      <div class="kit-escolha__texto">
        <span class="kit-escolha__rotulo">Quantas unidades?</span>
        <small class="kit-escolha__dica">De {{config.incrementoCompra}} em {{config.incrementoCompra}} · mínimo {{config.qtdeMinimaCompra}}<ng-container *ngIf="config.qtdeMaximaCompra != null"> · máximo {{config.qtdeMaximaCompra}}</ng-container></small>
      </div>
      <div class="kit-stepper kit-stepper--destaque">
        <button type="button" aria-label="Diminuir unidades da montagem" (click)="passo(-1)" [disabled]="item.qtdeUnidadesKit <= config.qtdeMinimaCompra">−{{config.incrementoCompra}}</button>
        <input aria-label="Unidades da montagem" type="number" inputmode="numeric" [(ngModel)]="item.qtdeUnidadesKit" (ngModelChange)="atualize()" [min]="config.qtdeMinimaCompra" [max]="config.qtdeMaximaCompra" [step]="config.incrementoCompra">
        <button type="button" aria-label="Aumentar unidades da montagem" (click)="passo(1)" [disabled]="limiteAtingido">+{{config.incrementoCompra}}</button>
      </div>
    </div>
  </div>
  <div class="kit-sabores__topo">
    <span class="kit-sabores__rotulo">Escolha os sabores<ng-container *ngIf="config.qtdeMinimaPorSabor > 1"> · mínimo de {{config.qtdeMinimaPorSabor}} por sabor</ng-container></span>
    <button type="button" class="kit-link" (click)="dividir()">Dividir igualmente</button>
  </div>
  <ul class="kit-sabores">
    <li class="kit-sabor" *ngFor="let o of opcoes" [class.kit-sabor--ativo]="quantidade(o) > 0">
      <div class="kit-sabor__info">
        <span class="kit-sabor__nome">{{o.nome}}</span>
        <small class="kit-sabor__extra" *ngIf="o.valor">+ {{o.valor | currency:'BRL'}} por unidade</small>
        <button type="button" class="kit-link kit-sabor__completar" *ngIf="restante > 0" (click)="completar(o)">
          {{quantidade(o) > 0 ? 'Completar com mais ' + restante : 'Completar com ' + restante}}
        </button>
      </div>
      <div class="kit-stepper">
        <button type="button" [attr.aria-label]="'Diminuir ' + o.nome" (click)="passoSabor(o,-1)" [disabled]="quantidade(o) <= 0">{{passoRapido > 1 ? '−' + passoRapido : '−'}}</button>
        <input type="number" inputmode="numeric" [attr.aria-label]="'Quantidade de ' + o.nome" [ngModel]="quantidade(o)" (ngModelChange)="definir(o,$event)" min="0" step="1">
        <button type="button" [attr.aria-label]="'Aumentar ' + o.nome" (click)="passoSabor(o,1)" [disabled]="restante <= 0">{{passoRapido > 1 ? '+' + passoRapido : '+'}}</button>
      </div>
    </li>
  </ul>
  <footer class="kit-resumo" aria-live="polite" [class.kit-resumo--completo]="!erro && !aviso" [class.kit-resumo--alerta]="!!aviso || (erro && total > 0)">
    <div class="kit-barra"><span [style.width.%]="progresso"></span></div>
    <div class="kit-resumo__linha">
      <strong>{{total}} de {{item.qtdeUnidadesKit || 0}} unidades</strong>
      <span class="kit-resumo__status" role="status">{{aviso || erro || 'Completo ✓'}}</span>
    </div>
  </footer>
</section>
